import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  data: {
    summary: {},
    shipments: {},
    monthlyShipments: [],
    monthlyShipmentsSquareMeters: [],
  },
}

const dashboard = createSlice({
  name: 'carriersDashboard',
  initialState,
  reducers: {
    getDashboardRequest(state) {
      state.loading = true
    },
    getDashboardSuccess(state, { payload }) {
      state.loading = false

      state.data = {
        summary: payload.dashb_orders[0] || {},
        shipments: payload.dashb_loadings[0] || {},
        monthlyShipments: payload.dashb_shipments_count,
        monthlyShipmentsSquareMeters: payload.dashb_shipments_sqmtr,
      }
    },
    getDashboardFailure(state) {
      state.loading = false
    },
  },
})

export const { getDashboardFailure, getDashboardRequest, getDashboardSuccess } =
  dashboard.actions

export default dashboard.reducer
